module.exports = __webpack_public_path__ + "img/isls-works.aa90987f.png";